import React from 'react';

const StaffNameCell = ({ user }) => {
  const name = `${user?.firstName || ''} ${user?.lastName || ''}`?.trim();
  if (!name && !user?.userNumber) return '-';

  return (
    <>
      <div className="table-data-with-id">{name || '-'}</div>
      {user?.userNumber && (
        <div className="font-size-12">({user?.userNumber})</div>
      )}
    </>
  );
};

export default StaffNameCell;
